<template>
  <div id="app">
    <CookieChoice></CookieChoice>
    <Header msg="Header"/>
    <Maintenance msg="Maintenance"/>
    <Footer msg="Footer"/>
  </div>
</template>

<script>
/*componenti*/
import CookieChoice from '../../components/CookieChoice.vue'
import Header from '../../components/HeaderNoMenu.vue'
import Maintenance from '../../components/Maintenance.vue'
import Footer from '../../components/Footer.vue'


export default {
  name: 'app',
  components: {
    Header,
    Maintenance,
    Footer,
    CookieChoice,
  },
  constants: {
    HTMLTITLE: 'SCTOutil.VDA',
    NODE_ENV: process.env.NODE_ENV
  },
  data() {
      return {
        pageGA:'/default/maintenance',
      }},
   
  mounted(){
    
    //start bootstrap
    var recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', '/SCTProfessional/static/node_modules/startbootstrap-modern-business/vendor/jquery/jquery.min.js');
    document.head.appendChild(recaptchaScript);
    recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', '/SCTProfessional/static/node_modules/startbootstrap-modern-business/vendor/bootstrap/js/bootstrap.bundle.min.js');
    document.head.appendChild(recaptchaScript);
  }
}

</script>

